// Status das cameras (vem de GET /cameras/status, verificado pelo backend a
// cada 2 min perguntando ao DVR quais canais estao sem imagem).

export const STATUS = {
  ok: { rotulo: 'Funcionando', cor: '#4CB553', icone: 'bi-check-circle-fill' },
  sem_video: { rotulo: 'Sem imagem', cor: '#e5484d', icone: 'bi-exclamation-triangle-fill' },
  offline: { rotulo: 'Equipamento fora do ar', cor: '#7d8b90', icone: 'bi-wifi-off' },
  desconhecido: { rotulo: 'Sem informação', cor: '#d9a53a', icone: 'bi-question-circle-fill' },
};

export const ORDEM_STATUS = ['sem_video', 'offline', 'desconhecido', 'ok'];

export function infoStatus(status) {
  return STATUS[status] || STATUS.desconhecido;
}

// "há 5 min", "há 2 h", "desde 06/10 14:32".
export function formatarDesde(desde, agora = new Date()) {
  if (!desde) return '';
  const d = new Date(desde);
  const min = Math.floor((agora - d) / 60000);
  if (min < 1) return 'agora';
  if (min < 60) return `há ${min} min`;
  if (min < 24 * 60) return `há ${Math.floor(min / 60)} h`;
  const p2 = (n) => String(n).padStart(2, '0');
  return `desde ${p2(d.getDate())}/${p2(d.getMonth() + 1)} ${p2(d.getHours())}:${p2(d.getMinutes())}`;
}

// Quantas cameras em cada status: { ok: 3, sem_video: 1, ... }.
export function contarStatus(cameraIds, statusPorCamera) {
  const contagem = { ok: 0, sem_video: 0, offline: 0, desconhecido: 0 };
  for (const id of cameraIds) {
    const s = statusPorCamera.get(id)?.status || 'desconhecido';
    contagem[s in contagem ? s : 'desconhecido'] += 1;
  }
  return contagem;
}
